import * as React from 'react';
import { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  Box,
  Button,
  Container,
  Modal,
  Stack,
  Typography,
  DialogTitle,
} from '@mui/material';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Image,
  Font,
} from '@react-pdf/renderer';

// In a real app, you would import your logo
// import logo from '../Images/logo.png';
 
// Mock logo - replace with your actual logo import
import logo from '../Images/logo.png';

Font.register({
  family: 'KadwaRegular',
  src: 'https://fonts.gstatic.com/s/kadwa/v2/rnCm-x5V0g7ipiTAT8M.ttf',
});

Font.register({
  family: 'KadwaBold',
  src: 'https://fonts.gstatic.com/s/kadwa/v2/rnCr-x5V0g7ipix7atM5kn0.ttf',
});

Font.register({
  family: 'MontserratRegular',
  src: 'https://fonts.gstatic.com/s/montserrat/v12/JTUSjIg1_i6t8kCHKm459Wlhzg.ttf',
});

export default function PrintPDFQuotation(props) {
  const [openModal, setOpenModal] = useState(true);
  const details = props.data || {
    surName: 'John',
    clientName: 'Doe',
    ntn: '1234567890',
    clientAddress: '123 Main St, City, Country',
    date: new Date(),
    gst: 'yes',
    quotationId: 'Q12345',
    module: 'P2.5',
    category: 'Indoor',
    screenWidth: 10,
    screenHeight: 8,
    rate: 150,
    noOfScreen: 2,
    cardInfo: 'Standard Card',
    videoProcessor: 'Nova Pro',
    videoProcessorDescription: 'High-performance processor',
    payment: '50% advance, 50% on delivery',
    warranty: '2 years',
    validity: '2 weeks'
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    if (props.onClose) props.onClose();
  };

  const numberWithCommas = (x) =>
    x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  const dueDate = new Date(details.date);
  dueDate.setDate(dueDate.getDate() + 5);

  // Module specs function
  const getModuleSpecs = (module) => {
    const m = module.toLowerCase().replace(/\s/g, '');
    switch (m) {
      case 'p1.5':
      case 'p 1.5':
        return (
          <>
            LED Type: SMD1212{'\n'}
            Pixel Pitch: 1.538mm{'\n'}
            Contrast Ratio: 10000 : 1{'\n'}
            Refresh Rate: 7680Hz{'\n'}
            Module Resolution: 208×104=21632 Pixels{'\n'}
            Beam Angle (Hor°/Ver°): 160°/160°{'\n'}
          </>
        );
      case 'p1.8':
      case 'p 1.8':
        return (
          <>
            LED Type: SMD1515{'\n'}
            Pixel Pitch: 1.86mm{'\n'}
            Contrast Ratio: 5000 : 1{'\n'}
            Refresh Rate: 3840Hz{'\n'}
            Module Resolution: 172×86=14792 Pixels{'\n'}
            Beam Angle (Hor°/Ver°): 140°/140°{'\n'}
          </>
        );
      case 'p2.5':
      case 'p 2.5':
        return (
          <>
            LED Type: SMD2121{'\n'}
            Pixel Pitch: 2.5mm{'\n'}
            Contrast Ratio: 5000 : 1{'\n'}
            Refresh Rate: 3840Hz{'\n'}
            Module Resolution: 128×64=8192 Pixels{'\n'}
            Beam Angle (Hor°/Ver°): 140°/140°{'\n'}
          </>
        );
      case 'p4':
      case 'p 4':
        return (
          <>
            LED Type: SMD2121{'\n'}
            Pixel Pitch: 4mm{'\n'}
            Contrast Ratio: 3000 : 1{'\n'}
            Refresh Rate: 1920Hz{'\n'}
            Module Resolution: 80×40=3200 Pixels{'\n'}
            Beam Angle (Hor°/Ver°): 140°/140°{'\n'}
          </>
        );
      case 'p5':
      case 'p 5':
        return (
          <>
            LED Type: SMD1921{'\n'}
            Pixel Pitch: 5mm{'\n'}
            Contrast Ratio: 3000 : 1{'\n'}
            Refresh Rate: 1920Hz{'\n'}
            Module Resolution: 64×32=2048 Pixels{'\n'}
            Beam Angle (Hor°/Ver°): 140°/140°{'\n'}
          </>
        );
      case 'p 8':
      case 'p8':
        return (
          <>
            LED Type: SMD2727{'\n'}
            Pixel Pitch: 8mm{'\n'}
            Contrast Ratio: 3000 : 1{'\n'}
            Refresh Rate: 1920Hz{'\n'}
            Module Resolution: 40×20=800 Pixels{'\n'}
            Beam Angle (Hor°/Ver°): 140°/140°{'\n'}
          </>
        );
      case 'p10':
      case 'p 10':
        return (
          <>
            LED Type: SMD3535{'\n'}
            Pixel Pitch: 10mm{'\n'}
            Contrast Ratio: 3000 : 1{'\n'}
            Refresh Rate: ≥1920Hz{'\n'}
            Module Resolution: 32×16=512 Pixels{'\n'}
            Beam Angle (Hor°/Ver°): 140°/120°{'\n'}
          </>
        );
      default:
        return null;
    }
  };

  const basePrice = details.screenWidth * details.screenHeight * details.rate;
  const totalPrice = basePrice * details.noOfScreen;
  const gstAmount = details.gst === 'yes' ? (totalPrice * 18) / 100 : 0;
  const grandTotal = totalPrice + gstAmount;

  const styles = StyleSheet.create({
    body: {
      padding: 20,
      fontFamily: 'KadwaRegular',
      fontSize: 9,
      color: '#222',
      backgroundColor: '#f9faff',
      position: 'relative',
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      borderBottomWidth: 2,
      borderBottomColor: '#0077c8',
      paddingBottom: 10,
      marginBottom: 15,
      paddingTop:10
    },
    headerLeft: {
      flexDirection: 'column',
      alignItems: 'center',
      width: 200,
    },
    logo: {
      width: 90,
      height: 55,
      marginBottom: 6,
    },
    companyName: {
      fontSize: 14,
      fontFamily: 'KadwaBold',
      color: '#0077c8',
      letterSpacing: 1,
      textAlign: 'center',
    },
    headerRight: {
      flex: 1,
      paddingLeft: '35%',
      fontSize: 8,
      fontFamily: 'KadwaBold',
      color: '#444',
      lineHeight: 1.3,
    },
    quotationToLabel: {
      fontSize: 11,
      fontFamily: 'KadwaBold',
      marginBottom: 4,
      color: '#0077c8',
      letterSpacing: 0.5,
      flexDirection: 'row',
      alignItems: 'center',
    },
    clientInfo: {
      fontSize: 9,
      marginBottom: 3,
      color: '#333',
      flexDirection: 'row',
      alignItems: 'center',
    },
    icon: {
      marginRight: 4,
      fontSize: 10,
      color: '#0077c8',
    },
    infoRibbon: {
      backgroundColor: '#0077c8',
      flexDirection: 'row',
      paddingVertical: 7,
      paddingHorizontal: 10,
      borderRadius: 5,
      marginBottom: 6,
      color: '#fff',
      fontFamily: 'KadwaBold',
      fontSize: 9,
      letterSpacing: 0.5,
    },
    infoRibbonText: {
      flex: 1,
      textAlign: 'center',
      color: '#fff',
    },
    infoRibbonValues: {
      backgroundColor: '#005a9c',
      flexDirection: 'row',
      paddingVertical: 7,
      paddingHorizontal: 10,
      borderRadius: 5,
      marginBottom: 15,
      fontFamily: 'KadwaRegular',
      fontSize: 8.5,
      color: '#e6f0ff',
    },
    infoRibbonValueText: {
      flex: 1,
      textAlign: 'center',
    },
    tableHeader: {
      flexDirection: 'row',
      backgroundColor: '#e1e9f8',
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
      paddingVertical: 8,
      paddingHorizontal: 10,
      marginBottom: 0,
      fontFamily: 'KadwaBold',
      fontSize: 9,
      color: '#0077c8',
      letterSpacing: 0.5,
    },
    tableHeaderText: {
      flex: 1,
      textAlign: 'center',
    },
    tableRow: {
      flexDirection: 'row',
      borderBottomWidth: 1,
      borderBottomColor: '#d1d9e6',
      paddingVertical: 10,
      paddingHorizontal: 10,
      backgroundColor: '#fff',
    },
    descriptionCell: {
      flex: 3,
      fontSize: 8.5,
      fontFamily: 'KadwaRegular',
      color: '#222',
      paddingRight: 6,
      lineHeight: 1.25,
    },
    sizeCell: {
      flex: 1,
      fontSize: 8.5,
      fontFamily: 'KadwaRegular',
      color: '#222',
      textAlign: 'center',
    },
    quantityCell: {
      flex: 1,
      fontSize: 8.5,
      fontFamily: 'KadwaRegular',
      color: '#222',
      textAlign: 'center',
    },
    priceCell: {
      flex: 1,
      fontSize: 8.5,
      fontFamily: 'KadwaRegular',
      color: '#222',
      textAlign: 'center',
    },
    unitPriceCell: {
      flex: 1,
      fontSize: 8.5,
      fontFamily: 'KadwaRegular',
      color: '#222',
      textAlign: 'center',
    },
    totalPriceCell: {
      flex: 1,
      fontSize: 9,
      fontFamily: 'KadwaBold',
      color: '#0077c8',
      textAlign: 'center',
    },
    summarySection: {
      marginTop: 20,
      padding: 12,
      backgroundColor: '#d9e8ff',
      borderRadius: 6,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontFamily: 'KadwaBold',
      fontSize: 11,
      color: '#004a8f',
      letterSpacing: 0.5,
    },
    summaryLabel: {
      flex: 2,
      flexDirection: 'row',
      alignItems: 'center',
    },
    summaryValue: {
      flex: 1,
      textAlign: 'right',
      fontSize: 12,
      color: '#d32f2f',
      fontFamily: 'KadwaBold',
    },
    termsSection: {
      marginTop: 25,
      padding: 15,
      backgroundColor: '#0077c8',
      borderRadius: 6,
    },
    termsTitle: {
      fontSize: 13,
      fontFamily: 'KadwaBold',
      color: '#fff',
      marginBottom: 10,
      textAlign: 'center',
      letterSpacing: 0.7,
    },
    termsText: {
      fontSize: 9,
      fontFamily: 'KadwaRegular',
      color: '#dbe9ff',
      marginBottom: 6,
      lineHeight: 1.3,
      flexDirection: 'row',
      alignItems: 'center',
    },
    termsTextBold: {
      fontFamily: 'KadwaBold',
      color: '#cce0ff',
      marginRight: 6,
    },
    footer: {
      marginTop: 'auto',
      fontSize: 9,
      fontFamily: 'KadwaRegular',
      color: '#666',
      textAlign: 'center',
      letterSpacing: 0.3,
      borderTopWidth: 1,
      borderTopColor: '#cbd6e8',
      paddingTop: 8,
      paddingBottom: 8,
      backgroundColor: '#f9faff',
    },
    decorativeTop: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 4,
      backgroundColor: '#0077c8',
    },
    decorativeBottom: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 4,
      backgroundColor: '#0077c8',
    },
    decorativeCornerTL: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 15,
      height: 15,
      borderTopWidth: 2,
      borderLeftWidth: 2,
      borderColor: '#0077c8',
    },
    decorativeCornerTR: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: 15,
      height: 15,
      borderTopWidth: 2,
      borderRightWidth: 2,
      borderColor: '#0077c8',
    },
    decorativeCornerBL: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: 15,
      height: 15,
      borderBottomWidth: 2,
      borderLeftWidth: 2,
      borderColor: '#0077c8',
    },
    decorativeCornerBR: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: 15,
      height: 15,
      borderBottomWidth: 2,
      borderRightWidth: 2,
      borderColor: '#0077c8',
    },
    pageWrapper: {
      flexDirection: 'column',
      height: '100%',
      paddingBottom: 20,
    },
    actualSizeText: {
      fontFamily: 'KadwaBold',
      color: '#d32f2f',
      marginTop: 4,
    },
  });

  // Unicode icons for simplicity
  const icons = {
    user: '👤',
    id: '🆔',
    calendar: '📅',
    module: '📦',
    payment: '💰',
    warranty: '🛡️',
    delivery: '🚚',
    power: '⚡',
    phone: '📞',
    email: '📧',
    address: '🏢',
    screen: '📺',
    quote: '📋',
    valid: '✅',
    total: '💲',
  };

  return (
    <Container>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Modal open={openModal} onClose={handleCloseModal}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 850,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 3,
                height: '95%',
                overflow: 'auto',
                borderRadius: 3,
              }}
            >
              <DialogTitle
                sx={{
                  textAlign: 'center',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 1,
                  backgroundColor: '#f0f7ff',
                  borderRadius: '8px 8px 0 0',
                  padding: '12px 20px',
                }}
              >
                <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: '#0077c8', fontSize: 18, display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: 8, fontSize: 20 }}>{icons.quote}</span>
                  Quotation Preview
                </Typography>
                <Button onClick={handleCloseModal} variant="outlined" color="primary" size="small" sx={{ borderRadius: 20 }}>
                  Close Preview
                </Button>
              </DialogTitle>

              <PDFViewer width="100%" height="700" style={{ border: 'none', borderRadius: '0 0 8px 8px' }}>
                <Document>
                  <Page size="A4" style={styles.body}>
                    {/* Use a wrapper to manage footer placement */}
                    <View style={styles.pageWrapper}>
                      {/* Decorative elements */}
                      <View style={styles.decorativeTop} />
                      <View style={styles.decorativeBottom} />
                      <View style={styles.decorativeCornerTL} />
                      <View style={styles.decorativeCornerTR} />
                      <View style={styles.decorativeCornerBL} />
                      <View style={styles.decorativeCornerBR} />

                      {/* Header */}
                      <View style={styles.header}>
                        <View style={styles.headerLeft}>
                          <Image style={styles.logo} src={logo} />
                          <Text style={styles.companyName}>AioDock Digital</Text>
                        </View>
                        <View style={styles.headerRight}>
                          <Text style={styles.quotationToLabel}>
                            <Text style={styles.icon}>{icons.user}</Text> Quotation to
                          </Text>
                          <Text style={styles.clientInfo}>
                            <Text style={styles.icon}>{icons.user}</Text> {details.surName} {details.clientName}
                          </Text>
                          
                          <Text style={styles.clientInfo}>
                            <Text style={styles.icon}>{icons.address}</Text> {details.clientAddress}
                          </Text>
                        </View>
                      </View>

                      {/* Info Ribbon */}
                      {/* <View style={styles.infoRibbon}>
                        {details.gst === 'yes' ? (
                          <>
                            <Text style={styles.infoRibbonText}>
                              <Text style={styles.icon}>{icons.calendar}</Text> Date
                            </Text>
                            <Text style={styles.infoRibbonText}>
                              <Text style={styles.icon}>{icons.id}</Text> NTN No.
                            </Text>
                            <Text style={styles.infoRibbonText}>
                              <Text style={styles.icon}>{icons.quote}</Text> Quotation No #
                            </Text>
                            <Text style={styles.infoRibbonText}>
                              <Text style={styles.icon}>{icons.screen}</Text> Module
                            </Text>
                          </>
                        ) : (
                          <>
                            <Text style={styles.infoRibbonText}>
                              <Text style={styles.icon}>{icons.calendar}</Text> Date
                            </Text>
                            <Text style={styles.infoRibbonText}>
                              <Text style={styles.icon}>{icons.quote}</Text> Quotation No #
                            </Text>
                            <Text style={styles.infoRibbonText}>
                              <Text style={styles.icon}>{icons.screen}</Text> Module
                            </Text>
                          </>
                        )}
                      </View> */}
                      <View style={styles.infoRibbonValues}>
                        {details.gst === 'yes' ? (
                          <>
                            <Text style={styles.infoRibbonValueText}>
                              {new Date(details.date).toLocaleDateString()}
                            </Text>
                            <Text style={styles.infoRibbonValueText}>A042167-2</Text>
                            <Text style={styles.infoRibbonValueText}>{details.quotationId}</Text>
                            <Text style={{fontFamily: 'KadwaBold'}}>
                              {details.module} {details.category}
                            </Text>
                          </>
                        ) : (
                          <>
                            <Text style={styles.infoRibbonValueText}>
                              {new Date(details.date).toLocaleDateString()}
                            </Text>
                            <Text style={styles.infoRibbonValueText}>{details.quotationId}</Text>
                            <Text style={{...styles.infoRibbonValueText,fontFamily: 'KadwaBold'}}>
                              {details.module} {details.category}
                            </Text>
                          </>
                        )}
                      </View>

                      {/* Table Header */}
                      <View style={styles.tableHeader}>
                        <Text style={{
                           flex: 3,
                           textAlign: 'center'
                        }}>Description</Text>
                        <Text style={styles.tableHeaderText}>Size (Sq.Ft)</Text>
                        <Text style={styles.tableHeaderText}>Quantity</Text>
                        <Text style={styles.tableHeaderText}>Price Sq.Ft</Text>
                        <Text style={styles.tableHeaderText}>Unit Price</Text>
                        <Text style={styles.tableHeaderText}>Total Price</Text>
                      </View>

                      {/* Table Row */}
                      <View style={styles.tableRow}>
                        <Text style={styles.descriptionCell}>
                          <Text style={{ fontFamily: 'KadwaBold', color: '#0077c8' }}>
                            {details.module} - {details.category} SMD Screen
                          </Text>
                          {'\n'}
                          <Text style={styles.actualSizeText}>
                            Actual Size: {details.screenWidth} Ft (W) by {details.screenHeight} Ft (H)
                          </Text>
                          {'\n'}
                          UNILUMIN{'\n\n'}
                          <Text style={{ fontFamily: 'KadwaBold' }}>Receiving Card:</Text> {details.cardInfo}{'\n'}
                          <Text style={{ fontFamily: 'KadwaBold' }}>Video Processor:</Text> {details.videoProcessor}{'\n'}
                          <Text style={{ fontFamily: 'KadwaBold' }}>Video Processor Description:</Text> {details.videoProcessorDescription}{'\n\n'}
                          {getModuleSpecs(details.module)}
                         
                        </Text>
                        <Text style={styles.sizeCell}>
                          {(details.screenWidth * details.screenHeight).toFixed(2)}
                        </Text>
                        <Text style={styles.quantityCell}>{details.noOfScreen}</Text>
                        <Text style={styles.priceCell}>
                          {numberWithCommas(parseInt(details.rate, 10).toFixed(0))}
                        </Text>
                        <Text style={styles.unitPriceCell}>{numberWithCommas(basePrice.toFixed(0))}</Text>
                        <Text style={styles.totalPriceCell}>{numberWithCommas(totalPrice.toFixed(0))}</Text>
                      </View>

                      {/* GST Row */}
                      {details.gst === 'yes' && (
                        <View style={styles.tableRow}>
                          <Text style={[styles.descriptionCell, { flex: 5, textAlign: 'right', fontFamily: 'KadwaBold' }]}>
                            GST (18%)
                          </Text>
                          <Text style={[styles.totalPriceCell, { flex: 1 }]}>
                            {numberWithCommas(gstAmount.toFixed(2))}
                          </Text>
                        </View>
                      )}

                      {/* Summary */}
                      <View style={styles.summarySection}>
                        <Text style={styles.summaryLabel}>
                          <Text style={styles.icon}>{icons.valid}</Text> Valid Till: {dueDate.toLocaleDateString()}
                        </Text>
                       
                        <Text style={styles.summaryValue}>
                          {numberWithCommas(grandTotal.toFixed(0))} /- PKR
                        </Text>
                      </View>

                      {/* Terms & Conditions */}
                      <View style={styles.termsSection}>
                        <Text style={styles.termsTitle}>
                          <Text style={{ marginRight: 8 }}>📋</Text>
                          Terms & Conditions
                        </Text>
                        <Text style={styles.termsText}>
                          <Text style={styles.termsTextBold}>{icons.payment} Payment:</Text> {details.payment}
                        </Text>
                        <Text style={styles.termsText}>
                          <Text style={styles.termsTextBold}>{icons.warranty} Service Warranty:</Text> {details.warranty}
                        </Text>
                        <Text style={styles.termsText}>
                          <Text style={styles.termsTextBold}>{icons.delivery} Delivery Time:</Text> {details.validity}
                        </Text>
                        <Text style={styles.termsText}>
                          <Text style={styles.termsTextBold}>{icons.power} Power Stability:</Text> Stabilised Power is the responsibility of Client.
                        </Text>
                      </View>

                      {/* Footer - now positioned correctly at the bottom */}
                      <View style={styles.footer}>
                        <Text style={{ marginBottom: 4, fontFamily: 'KadwaBold', color: '#0077c8' }}>
                          AioDock Digital {'\n'} Digital Standee | Pole Streamer | Conference Room Solutions | InDoor Video Wall | 3D SMD Solutions
                        </Text>
                        <Text>
                          <Text style={styles.icon}>{icons.address}</Text> Office No. 404, Hamdan Heights, Islamabad Expressway, Islamabad.
                          {'  '}
                          <Text style={styles.icon}>{icons.email}</Text> info@aiodock.com
                          {'  '}
                          <Text style={styles.icon}>{icons.phone}</Text> +92 318 7745768
                        </Text>
                      </View>
                    </View>
                  </Page>
                </Document>
              </PDFViewer>
            </Box>
          </Modal>
        </Stack>
      </LocalizationProvider>
    </Container>
  );
}